require('dotenv').config()

/// /////////////////////////
//    Minimart API
/// /////////////////////////'

export const MM_API_BASE_URL = process.env.VUE_APP_MM_API_BASE_URL
export const SQUARE_APP_ID = process.env.VUE_APP_SQUARE_APP_ID
export const SQUARE_ACCESS_TOKEN =
  process.env.VUE_APP_SQUARE_ACCESS_TOKEN || false
export const SQUARE_IS_IN_SANDBOX =
  process.env.VUE_APP_SQUARE_ENV === 'sandbox' &&
  process.env.NODE_ENV !== 'production'

/// /////////////////////////
//    SENTRY
/// /////////////////////////

export const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN
export const SENTRY_PROJECT_ID = process.env.VUE_APP_SENTRY_PROJECT_ID
